var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMybusiness1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1875 19.5498H14.625L24 46.0938H45.1875V19.5498Z",
    fill: "#4175DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 19.5498H24V46.0938H2.8125V19.5498Z",
    fill: "#4086F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.6016L24 23.6875C24 27.0012 26.6863 29.6875 30 29.6875C33.3137 29.6875 36 27.0012 36 23.6875L42 15.6016H18Z",
    fill: "#609AF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15.6016V23.6875C36 27.0012 38.6863 29.6875 42 29.6875C45.3137 29.6875 48 27.0012 48 23.6875V21.2266L36 15.6016Z",
    fill: "#23346D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.6016L12 23.6875C12 27.0012 14.6863 29.6875 18 29.6875C21.3137 29.6875 24 27.0012 24 23.6875V15.6016H6Z",
    fill: "#324492"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.2266V23.6875C0 27.0012 2.68631 29.6875 6 29.6875C9.31369 29.6875 12 27.0012 12 23.6875V15.6016L0 21.2266Z",
    fill: "#80AEF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11625 3.71875L0 21.2266H12L18 12.4727L15.0581 3.71875H6.11625Z",
    fill: "#9FC2F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48 21.2266L41.8838 3.71875H32.9419L30 12.4727L36 21.2266H48Z",
    fill: "#324492"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9419 3.71875H24L18 12.4727L24 21.2266H36L32.9419 3.71875Z",
    fill: "#80AEF8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0581 3.71875L12 21.2266H24V3.71875H15.0581Z",
    fill: "#4254B6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMybusiness1);
export default __webpack_public_path__ + "static/media/mybusiness-1.6e14f23b168518a1e154361ed953a5f8.svg";
export { ForwardRef as ReactComponent };